
<div>
  <VueFileAgent
     ref="fileAgent"
    :multiple="true"
    :deletable="true"
    :meta="true"
    :accept="'.pdf,.zip, .ppt, .pptx, .doc,.docx, .xls, .xlsx , .pdf, .hwp, .txt, .csv, .hwpx'"
    :maxSize="'2048MB'"
    :maxFiles="maxFiles"
    :helpText="selectText"
    :errorText="{
      type: errorMessage,
      size: errorSize,
    }"
    :thumbnailSize="120"
    :theme="'list'"
     v-model="fileRecords"
     @select="filesSelected($event)"     
     @beforedelete="onBeforeDelete($event)"
     @delete="onDelete($event)"
  ></VueFileAgent>
</div>
